import React, { useState, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useTranslation } from 'react-i18next'
import { mediaActions } from '../actions'
import Spinner from 'srcReact/components/common2/Spinner'
import NotFound from 'srcReact/components/common2/NotFound'
import useInfinitScroll from 'srcReact/helpers/hooks/useInfinitScroll'
import SearchTextBox from 'srcReact/components/common2/SearchTextBox'
import LinkPreview from 'srcReact/components/common2/LinkPreview'
import Masonry from 'srcReact/components/common2/Masonry'
import parentStyles from '../styles.module.scss'
import styles from './styles.module.scss'

function LinkList({ type, id, noDatatitle, handleDelete, deleteFileLoading, isStatic }) {
  const { t } = useTranslation()

  const dispatch = useDispatch()

  const [pagination, setPagination] = useState({
    nextOffset: 0,
    isPagination: false
  })
  const [search, setSearch] = useState('')

  const {
    common: { isMobile },
    media: { links }
  } = useSelector((state) => state)

  useEffect(() => {
    if (!isStatic) {
      dispatch(mediaActions.getLinks(type, id, pagination, search))
    }
  }, [pagination, search])

  const lastLinkRef = useInfinitScroll(
    links.loading,
    links.stats && links.stats.remaining,
    links.stats && links.stats.next_offset,
    setPagination,
    [links.loading]
  )

  const handleSearch = (text) => {
    setSearch(text)
  }

  return (
    <React.Fragment>
      {!links.loading && links.list && links.list.length === 0 ? (
        <NotFound title={noDatatitle} className={styles.notFoundWrapper} />
      ) : (
        <React.Fragment>
          <div className={parentStyles.actions}>
            <SearchTextBox
              placeholder={isMobile ? t('global.search') : t('formlabel.searchLinkPlaceholder')}
              handleSearch={handleSearch}
              minimumSearchChar={2}
            />
          </div>
          <Masonry columns={isMobile || links?.list?.length === 1 ? 1 : 2}>
            {links?.list &&
              links.list.map((link, index) => {
                const isLast = links.list.length === index + 1
                return (
                  <div key={index} ref={isLast ? lastLinkRef : null}>
                    <LinkPreview
                      data={`<div><a href=${link} rel="noopener noreferrer" target="_blank">${link}</a></div>`}
                      containerCSS={styles.linkContainerCSS}
                      linkCSS={styles.linkCSS}
                      previewCSS={styles.previewCSS}
                    />
                  </div>
                )
              })}
          </Masonry>
        </React.Fragment>
      )}
      {links.loading && <Spinner />}
    </React.Fragment>
  )
}

export default LinkList
